document.addEventListener('DOMContentLoaded', () => {
  // qikify owns this popup; keep its legacy scope statement aligned with SACRED15.
  const correctDiscountCopy = (root) => {
    const update = (node) => {
      if (node.parentElement?.closest('script, style, noscript, textarea')) return;
      const original = node.nodeValue || '';
      const corrected = original.replace(
        /applies to all items and first time clients only!?/gi,
        'for first-time customers. Excludes jewelry and cacao.'
      );
      if (corrected !== original) node.nodeValue = corrected;
    };
    if (root.nodeType === Node.TEXT_NODE) return update(root);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) update(walker.currentNode);
  };
  correctDiscountCopy(document.body);
  new MutationObserver((records) => {
    records.forEach((record) => {
      if (record.type === 'characterData') correctDiscountCopy(record.target);
      else record.addedNodes.forEach(correctDiscountCopy);
    });
  }).observe(document.body, { childList: true, characterData: true, subtree: true });

  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  // Shopify can partially add inventory before returning an overstock error.
  subscribe(PUB_SUB_EVENTS.cartError, async () => {
    try {
      const response = await fetch(`${window.routes.cart_url}?sections=cart-icon-bubble`);
      if (!response.ok) return;
      const sections = await response.json();
      if (!sections['cart-icon-bubble']) return;
      const html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      const content = html.querySelector('.shopify-section');
      const bubble = document.getElementById('cart-icon-bubble');
      if (content && bubble) bubble.innerHTML = content.innerHTML;
    } catch {
      // The product-form error and cart page remain available if refresh fails.
    }
  });
  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    const variantId = data?.variant?.id;
    if (!variantId) return;
    if (typeof window.triggerSwymVariantEvent === 'function') window.triggerSwymVariantEvent(variantId);
    if (window.booster) window.booster.currentVariantId = variantId;
  });
  if (document.querySelector('cart-items')) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items' && event.cartData && !event.cartData.errors) window.location.reload();
    });
  }
});

